import React from 'react';

interface EmailIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const EmailIcon: React.FC<EmailIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.9908 19.9992C9.62622 19.9992 
      7.26223 20.0016 4.89766 19.998C3.55676 
      19.9962 2.4485 19.1331 2.10956 17.8165C2.03811 
      17.538 2.00554 17.2397 2.00496 16.9504C1.9981 
      13.6501 1.99982 10.3492 2.00153 7.04835C2.00211 
      5.30168 3.2344 4.00491 4.8988 4.0025C7.76292 3.99889 
      10.6276 4.0013 13.4917 4.0013C15.3562 4.0013 17.2206 
      3.99769 19.0845 4.0025C20.5414 4.00611 21.6748 4.99072 
      21.9486 6.48658C21.9846 6.68386 21.9972 6.88896 21.9972 
      7.09045C22.0001 10.3763 22.0012 13.6621 21.9983 16.948C21.9972 
      18.4661 21.0707 19.663 19.6795 19.9451C19.4709 19.9872 19.2537 
      19.9962 19.0399 19.9968C16.6896 20.0004 14.3399 19.9992 11.9897 
      19.9992H11.9908ZM11.9868 12.538C11.9382 12.5019 11.9091 12.4808 
      11.8805 12.4586C9.83027 10.8677 7.77607 9.28101 5.73272 
      7.68049C5.40121 7.42066 5.00797 7.55539 4.81535 7.79477C4.58216 
      8.08408 4.59702 8.47564 4.85822 8.74931C4.92852 8.82269 5.0114 
      8.88344 5.09199 8.94599C7.22965 10.6018 9.36845 12.2571 11.5061 
      13.9129C11.8771 14.1998 12.0857 14.2034 12.452 13.9195C14.6023 
      12.2559 16.7525 10.5922 18.9005 8.92494C19.0022 8.84614 19.0954 
      8.7451 19.1668 8.63623C19.4514 8.20017 19.2805 7.73102 18.7953 
      7.57885C18.5672 7.50727 18.3798 7.57223 18.1957 7.71598C17.0211 
      8.63322 15.8437 9.54746 14.6669 10.4617C13.7775 11.1522 12.887 11.8409 11.9868 12.538Z"
      fill={color}
    />
  </svg>
);

export default EmailIcon;
